import { useQuery } from "urql";

import {
  GetLimitRequestPaymastersDocument,
  LimitRequestPaymasterFilter,
  LimitRequestPaymasterOrderBy,
} from "../../../../graphql/generated.ts";
import { ApiHookProps } from "../../types.ts";

export const useLimitRequestPaymasters = ({
  filter,
  orderBy,
  pause,
}: ApiHookProps<LimitRequestPaymasterFilter, LimitRequestPaymasterOrderBy>) => {
  const variables = {
    filter,
    orderBy,
  };
  return useQuery({
    query: GetLimitRequestPaymastersDocument,
    variables,
    pause,
  });
};
